import { render } from "./carRank.vue?vue&type=template&id=074a47c6&scoped=true&ts=true"
import script from "./carRank.vue?vue&type=script&lang=ts"
export * from "./carRank.vue?vue&type=script&lang=ts"

import "./carRank.vue?vue&type=style&index=0&id=074a47c6&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074a47c6"]])

export default __exports__